/**
 * Returns a function that as long as it continues to be invoked, won't be triggered.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Delay (in milliseconds).
 * @returns {Function}
 */
function debounce(fn, wait = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.announcement__slider');
      this.isPaused = false;

      this.bindEvents();
      this.init();
    }

    bindEvents() {
      if (this.slider) {
        this.slider.addEventListener('mouseenter', this.pauseSlider.bind(this));
        this.slider.addEventListener('mouseleave', this.resumeSlider.bind(this));
      }
    }

    /**
     * Start sliders a slidin'
     */
    init() {
      if (this.slider) {
        const slides = this.slider.querySelectorAll('.announcement__text');
        slides[0].classList.add('is-visible');

        const nextSlide = () => {
          if (!this.isPaused && theme.elementUtil.isInViewport(this)) {
            const currSlide = this.slider.querySelector('.announcement__text.is-visible');
            const currSlideIndex = Array.from(currSlide.parentNode.children)
              .indexOf(currSlide);
            const nextSlideIndex = currSlideIndex + 1 < slides.length ? currSlideIndex + 1 : 0;

            if (document.dir === 'rtl') {
              this.slider.scrollTo(
                -Math.abs(nextSlideIndex * slides[nextSlideIndex].clientWidth),
                0
              );
            } else {
              this.slider.scrollTo(slides[nextSlideIndex].offsetLeft - 32, 0);
            }

            slides[nextSlideIndex].classList.add('is-visible');
            slides[currSlideIndex].classList.remove('is-visible');
          }

          setTimeout(nextSlide, this.dataset.slideDelay);
        };
        setTimeout(nextSlide, this.dataset.slideDelay);
      }
    }

    /**
     * Pauses the auto-rotating slider
     */
    pauseSlider() {
      this.isPaused = true;
    }

    /**
     * Resumes the auto-rotating slider
     */
    resumeSlider() {
      this.isPaused = false;
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
